// extracted by mini-css-extract-plugin
export var dividerContainer = "_61-0";
export var line = "_61-1";